import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { PolicyForm, Test } from "@app/definitions/types"
import { AutocompleteMultiComponent } from "@app/gen-inputs/autocomplete-multi/autocomplete-multi.component"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { GenInputComponent } from "@app/gen-inputs/gen-input/gen-input.component"
import { Modalable } from "@app/Modalable"
import { Versions } from "@app/update-policy-form/versions/versions.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-update-policy-form",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		GenInputComponent,
		AutocompleteMultiComponent,
		Versions,
		BtnExtComponent,
		GenButtonGroupComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./update-policy-form.component.html",
})
export class UpdatePolicyFormComponent extends Modalable {
	@Input() policyForm: PolicyForm
	policyForms: any[] = []
	isSaving: boolean = false
	errors: any = {} //will hold errors for the fields in the form
	isFormSubmittable: boolean = false //can submit (controls disabled in the submit button)
	validationFields: any = {
		name: { not_empty: true, unique: true },
	}

	ngOnInit() {
		if (!this.policyForm) {
			this.policyForm = new PolicyForm()
		}
		this.policyForms = this.store.getSiteDataTable("policy_forms")
	}
	validateAndSave(fieldName: string) {
		if (!this.policyForm.id) {
			return this.validateEntireForm()
		}
		this.validateEntireForm()
		this.saveField(fieldName)
	}

	validateEntireForm() {
		//validate all fields and detrmine if can be submitted (or has errors)
		this.isFormSubmittable = this.validator.validateEntireForm(
			this.policyForm,
			this.errors,
			this.validationFields,
			this.policyForms
		)
	}
	onPersonTypesAdd(obj: any) {
		this.policyForm.person_types = [...this.policyForm.person_types, obj.id]
		this.validateAndSave("person_types")
	}
	onPersonTypesDelete(id: any) {
		this.policyForm.person_types = this.policyForm.person_types.filter(
			(it) => it != id
		)
		this.validateAndSave("person_types")
	}

	async saveField(fieldName: string) {
		if (!this.isFormSubmittable) {
			return
		}

		const res: any = await this.apiService.save_gen_field(
			"policy_forms",
			this.policyForm.id,
			fieldName,
			this.policyForm[fieldName]
		)
		if (res?.success) {
			this.store.updGenItemRowField(
				"policy_forms",
				this.policyForm.id,
				fieldName,
				this.policyForm[fieldName]
			)
			this.store.refreshTableSubject.next("policy_forms")
			this.modalService.openToast("update_successfuly")
		} else {
			this.modalService.openToast("save_failed")
		}
	}
	async save() {
		//save the contact
		if (!this.isFormSubmittable) {
			return
		}
		await this.apiService.sendApiGetPerms()
		if (
			!this.apiService.apiCallPerms ||
			!this.apiService.apiCallPerms.policy_forms?.saveNewRow
		) {
			return
		}
		this.isSaving = true
		const res: any = await this.apiService.save_gen_item("policy_forms", {
			...this.policyForm,
		})
		this.isSaving = false
		if (res.id) {
			this.policyForm = res
			this.store.addGenItemRow("policy_forms", res)
			this.store.refreshTableSubject.next("policy_forms")
		}
		this.modalService.openToast(
			res?.id ? "saved_successfully" : res?.mes || "save_failed"
		)
		this.policyForms = this.store.getSiteDataTable("policy_forms")
	}
}
